var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42578 3.57812L3.71875 0.871094C3.58203 0.734375 3.39062 0.734375 3.25391 0.871094L0.546875 3.57812C0.328125 3.79688 0.492188 4.125 0.765625 4.125H2.73438V12.5469C2.73438 12.7383 2.87109 12.875 3.0625 12.875H3.9375C4.10156 12.875 4.26562 12.7383 4.26562 12.5469V4.125H6.20703C6.48047 4.125 6.64453 3.79688 6.42578 3.57812Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowUp);
export default __webpack_public_path__ + "static/media/long-arrow-up.d5f9a3b5280abdc66e7be852f6efc7c9.svg";
export { ForwardRef as ReactComponent };